<template>
  <div>
    <wc-data-box
      :title='getTitle.text'
      :titleIcon='getTitle.icon'
      :titleIconColor='getTitle.color'
      :showAdd='entry.hours_left_to_assign !== 0'
      @add="$emit('add')"
    >
      <v-list two-line v-if='workedOns.length' class='pa-0'>
        <v-list-item-group>
          <template v-for='(workedOn, index) in workedOns'>
            <v-list-item class='pl-2 py-0 pr-0' :key='workedOn.id' @click="$emit('edit', workedOn)">
              <v-list-item-avatar v-if='$vuetify.breakpoint.lg' class='mr-1'>
                <v-icon :color="workedOn.category_obj.division_obj.icon_color">
                  {{ workedOn.category_obj.division_obj.icon }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                    <v-icon v-if='$vuetify.breakpoint.mdAndDown' class='mr-2' :color="workedOn.category_obj.division_obj.icon_color">
                      {{ workedOn.category_obj.division_obj.icon }}
                    </v-icon>
                    <span v-if='workedOn.project' class='body-1 mr-2 font-weight-bold'>{{workedOn.project_obj.name}}</span>
                    <span v-else class='body-1 mr-2 font-weight-bold'>{{workedOn.category_obj.description}}</span>
                    <br v-if='$vuetify.breakpoint.mdAndDown'>
                    <span v-if='workedOn.detail' class='body-2'>{{workedOn.detail_obj.description}}</span>
                </v-list-item-title>

                <v-list-item-subtitle class='font-italic' v-if="workedOn.notes" v-text="workedOn.notes"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <div class='d-flex'>
                  <span class='body-1 mr-2 pt-2 font-weight-bold'>{{ workedOn.num_hours.toFixed(2) }}</span>
                  <v-btn icon @click="$emit('delete', workedOn)">
                    <v-icon color="grey lighten-1">mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-list-item-action>
            </v-list-item>

            <v-divider
              v-if="index < workedOns.length - 1"
              :key="index"
            ></v-divider>

          </template>
        </v-list-item-group>
      </v-list>
            

      <div class='grey--text ml-3 pa-1' v-else>No hours assigned.</div>
    </wc-data-box>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'timesheets-overview-details',
  props: {
    entry: {
      required: true
    },
    workedOns: {
      required: true
    }
  },
  mixins: [formRules],
  data: () => ({
    label: 'grey--text',
    dataValue: 'text-right',
  }),
  computed:{
    getTitle () {
      let hrs = this.entry.hours_left_to_assign
      if (!hrs) {
        return {text: 'Details', icon: 'mdi-format-list-bulleted', color: 'info'}
      } else if (hrs < 0) {
        return {text: 'Remove a detail', icon: 'mdi-alert-octagon-outline', color: 'error'}
      } else {
        let calc = hrs.toFixed(2) + ' hr' + (hrs <= 1 ? '' : 's') + ' to assign'
        return {text: calc, icon: 'mdi-alert-outline', color: 'purple'}
      }
    },
  },
  methods: {

  },
  components: {

  }
}
</script>